/**
 * Phase 47.2 — Price-per-SqFt / Price-per-SqM normalisation helpers.
 *
 * Frontend mirror of `backend/pricing_normalisation.py` — same rules
 * (sqft ≥ 50, dollar-precision, "—" on edge cases) so the live wizard
 * preview chip lands on the same string the persisted PDF / Reports
 * preview render.
 */
const SQM_PER_SQFT = 0.092903;
const MIN_SQFT = 50;

function _saneSqft(sqft) {
  if (sqft == null || sqft === "") return null;
  const v = Number(sqft);
  if (!Number.isFinite(v) || v < MIN_SQFT) return null;
  return v;
}

export function pricePerSqft(price, sqft) {
  const s = _saneSqft(sqft);
  if (s == null || price == null) return null;
  const p = Number(price);
  if (!Number.isFinite(p) || p <= 0) return null;
  return p / s;
}

export function pricePerSqm(price, sqft) {
  const psf = pricePerSqft(price, sqft);
  if (psf == null) return null;
  return psf / SQM_PER_SQFT;
}

/**
 * Returns the canonical "$367/sqft · $3,956/sqm" string, or "—" when
 * either side of the pair is invalid. Use this anywhere we render
 * both metrics in the same span so a bad-sqft property never shows
 * a half-rendered "$367/sqft · —".
 */
export function formatPsfPsm(price, sqft) {
  const psf = pricePerSqft(price, sqft);
  const psm = pricePerSqm(price, sqft);
  if (psf == null || psm == null) return "—";
  const fmt = (n) =>
    "$" + Math.round(n).toLocaleString("en-US");
  return `${fmt(psf)}/sqft · ${fmt(psm)}/sqm`;
}

/**
 * Compact "$367/sqft" only (no PSM). Used in tight rows like the
 * Dashboard Recent Deals table where dual-display would crowd the
 * column.
 */
export function formatPsfShort(price, sqft) {
  const psf = pricePerSqft(price, sqft);
  if (psf == null) return null;
  return `$${Math.round(psf).toLocaleString("en-US")}/sqft`;
}
